import styled from 'styled-components'

import { Body, Heading2 } from 'components/Typography'
import { style } from 'theme'

export const Container = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  padding-bottom: 50px;
  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    padding-bottom: 30px;
  }
`

export const Title = styled(Heading2)`
  font-size: 16px;
  margin-bottom: 10px;
`

export const Subtitle = styled(Body)`
  margin: 0 auto;
  max-width: 450px;
`

export const PricingText = styled(Body)`
  text-align: center;
  margin-bottom: 10px;
`

export const RecommendationContainer = styled.div`
  background: rgb(255, 255, 255);
  border-radius: 8px;
  border: 2px solid rgb(116, 201, 71);
  box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.06);
  height: 100%;
  width: 335px;
  margin: 0 auto;
  margin-top: 30px;
  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    width: 100%;
  }
`
